import React, { useEffect, useState, useCallback } from 'react'

import {
	Box,
	Alert,
	AlertTitle,
	IconButton,
	Tooltip,
	Tab,
	Tabs,
} from '@mui/material'

import {
    LineChart,
    Line,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip as RechartsTooltip,
    ResponsiveContainer,
} from 'recharts';

import LoadingButton from '@mui/lab/LoadingButton';

import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

import AddBotDialog from "./AddBotDialog/index.js"
import ConfirmationDialogCaptcha from '../../Dialogs/ConfimationDialogCaptcha/index.js';
import useNotification from "../../Notification/index.js";
import Loading from '../../Loading/index.js';
import api from '../../../api.js';
import EditIcon from '@mui/icons-material/Edit';

import { getSession } from '../../../auth.js';

import './styles.css'

const Sms = ({ enterprise }) => {

	const [loading, setLoading] = useState(false);
	const [bots, setBots] = useState([]);
	const [showAddBot, setShowAddBot] = useState(null)
	const [deleteModal, setDeleteModal] = useState(null)

	const [tab, setTab] = useState(0)

	const [smsUsage, setSmsUsage] = useState([])
	const [smsFetched, setSmsFetched] = useState(false)

	const deleteBot = async (id) => {
		const enterpriseId = getSession().profile.enterprise.id;
		setLoading(true)
		const res = await api.delete(`/api/enterprises/${enterpriseId}/sms/${id}/`)
		setLoading(false)
		if (res.status !== 204) {
			useNotification(
				'Ops!',
				'Ocorreu um erro na requisição.',
				'danger'
			);
			return
		}
		setBots(bots.filter((bot) => bot.id != id))
		setDeleteModal(null)
	}

	const addBot = async (data) => {
		const enterpriseId = getSession().profile.enterprise.id;
		const id = data.id
		const validationData = { ...data }
		delete validationData.id

		let res = null
		setLoading(true)
		if (id === 0)
			res = await api.post(`/api/enterprises/${enterpriseId}/sms/`, validationData)
		else
			res = await api.patch(`/api/enterprises/${enterpriseId}/sms/${id}/`, validationData)
		setLoading(false)

		if (![200, 201].includes(res.status)) {
			if (res.status === 404) {
				useNotification(
					'Ops!',
					'Não foi possível registrar o sms, verifique as suas credenciais.',
					'danger'
				)
			}

			else if (res.status === 409) {
				useNotification(
					'Ops!',
					'Número já vinculado a outra conta.',
					'danger'
				)
			}
			return

		}

		const foundbot = bots.find(each => each.id === res.data.id)
		if (foundbot)
			Object.assign(foundbot, res.data)
		else
			setBots([...bots, res.data])

		setShowAddBot(null)
	}

	useEffect(() => {
		const fetchData = async () => {
			const enterpriseId = getSession().profile.enterprise.id;
			setLoading(true);
			const res = await api.get(`/api/enterprises/${enterpriseId}/sms/`);
			setLoading(false);

			if (res.status !== 200) {
				useNotification(
					'Ops!',
					'Não foi possível encontrar os bots de sms.',
					'danger'
				);
				return
			}

			setBots(res.data)
		};
		fetchData()
	}, [])

	useEffect(() => {
		const fetchSms = async () => {
			const enterpriseId = getSession().profile?.enterprise?.id
			if (enterpriseId) {
				const response = await api.get(`api/enterprises/${enterpriseId}/sms/usage/`)
				if (response.status === 200) {
					setSmsUsage(response.data)
					setSmsFetched(true)
				}
			}
		}
		
		if (tab === 1 && ! smsFetched)
			fetchSms()
	}, [tab])

	if (!enterprise?.platforms?.sms) {
		return (
			<Box>
				<Alert severity="info">
					Entre em contato com seu gerente de contas para contratar o canal SMS - <a href="https://wa.link/0bs73j">Clique aqui.</a>
				</Alert>
			</Box>
		)
	}

	return (
		<Box className="input-settings settings-body">
			<Loading loading={loading} />
			{showAddBot &&
				<AddBotDialog
					data={showAddBot}
					handleClose={() => setShowAddBot(null)}
					submit={addBot}
				/>
			}
			{deleteModal ?
				<ConfirmationDialogCaptcha open={true}
					title="Excluir página."
					description={
						<span>
							Para confirmar a ação, digite: <span style={{ 'fontWeight': 'bold' }}>remover</span> no campo abaixo.</span>}
					handleClose={() => { setDeleteModal(null) }}
					handleSubmit={() => { deleteBot(deleteModal) }}
					captcha={'remover'}
				/> : null
			}

			<Tabs
				value={tab}
				onChange={(event, newValue) => {
					setTab(newValue);
				}}
				sx={{
					borderBottom: 1,
					borderColor: 'divider',
					marginBottom: 3
				}}
			>
				<Tab label="Números" />
				<Tab label="Consumo" />
			</Tabs>

			{tab === 0 && (
				<>
					<Alert className="telegram-info" severity="info">
						<AlertTitle>
							Para saber como integrar o kwik com SMS <a href="https://instant.getoutline.com/s/kwik-integracoes/doc/integracao-sms-lmUhvyAs2t" target="_blank">clique aqui.</a>
						</AlertTitle>
					</Alert>
					{bots.length !== 0 &&
						<>
							<Box className="category-title push-bottom push-top">
								SMS(s)
							</Box>
							<Box className="telegram-bots">
								<table>
									{bots.map((item, index) => (
										<tr>
											<td>Telefone: {item.phone_number}</td>
											<td>
												<Tooltip title="Editar">
													<IconButton onClick={() => { setShowAddBot(item) }}>
														<EditIcon className='editicon' />
													</IconButton>
												</Tooltip>
												<Tooltip title="Excluir">
													<IconButton onClick={() => setDeleteModal(item.id)}>
														<DeleteIcon />
													</IconButton>
												</Tooltip>
											</td>
										</tr>
									))}
								</table>
							</Box>
						</>
					}

					<Box className="email-add-button">
						<LoadingButton startIcon={<AddIcon />} variant="contained"
							onClick={() => setShowAddBot({})}
						>
							Adicionar
						</LoadingButton>
					</Box>
				</>
			)}

			{tab === 1 && (
				<Box sx={{ width: "100%", flex: 1, minHeight: 0, padding: "1rem 1rem 1rem 0rem" }}>
					<ResponsiveContainer width="100%" height="100%">
						<LineChart
							data={smsUsage}
							margin={{
								top: 5,
								right: 30,
								left: 20,
								bottom: 5,
							}}
						>
							<CartesianGrid stroke="#E2E2E2" vertical={false} />

							<XAxis
								dataKey="period_date"
								tickFormatter={(value) => {
									const date = new Date(value);
									return `${String(date.getUTCMonth() + 1).padStart(2, '0')}/${date.getUTCFullYear()}`;
								}}
							/>

							<YAxis allowDecimals={false} />

							<RechartsTooltip
								labelFormatter={(value) => {
									const date = new Date(value);
									return `${String(date.getUTCMonth() + 1).padStart(2, '0')}/${date.getUTCFullYear()}`;
								}}
							/>

							<Line
								type="linear"
								dataKey="sms"
								name="SMS enviados"
								stroke="#1976D2"
								strokeWidth={2}
							/>
						</LineChart>
					</ResponsiveContainer>
				</Box>
			)}

		</Box>
	)
}

export default Sms
